"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgRefreshCw = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M16.453 26.666a8 8 0 005.776 5.134 8.015 8.015 0 007.446-2.169l2.64-2.36a1 1 0 011.37 1.458l-2.618 2.338a10 10 0 01-16.5-3.733 1 1 0 011.886-.668zM35 25a1 1 0 011 1v6a1 1 0 01-2 0v-5h-5a1 1 0 010-2h6zM13 15a1 1 0 011 1v5h5a1 1 0 010 2h-6a1 1 0 01-1-1v-6a1 1 0 011-1zm13.212-.751a10 10 0 017.22 6.417 1 1 0 01-1.885.668 8 8 0 00-5.776-5.134 8.015 8.015 0 00-7.446 2.169l-2.64 2.36a1 1 0 01-1.37-1.458l2.618-2.338a10 10 0 019.28-2.684z",
    id: "refresh-cw_svg__a"
  }));
};

var _default = SvgRefreshCw;
exports.default = _default;